// @flow

import {usdc} from '@tectonics/commons/cryptocurrency/cryptocurrencies/usdc/usdc';
import type {Cryptocurrency} from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrency-type';
import {usdt} from '@tectonics/commons/cryptocurrency/cryptocurrencies/usdt/usdt';
import type {OpenedIncomingPayment} from '@tectonics/prs/incoming-payment';
import {getCheckoutPaymentOptionsV2} from '@tectonics/prs/incoming-payment/get-checkout-payment-options';

export const allCryptocurrencyTypes: Array<Cryptocurrency> = [
  usdt,
  usdc,
];

export function getCryptocurrencyFromPaymentTypeCode(paymentTypeCode: string): Cryptocurrency {
  const cryptocurrency = allCryptocurrencyTypes.find(
    cryptocurrency => cryptocurrency.code === paymentTypeCode
  );

  if (!cryptocurrency) {
    throw new Error(`There is no Cryptocurrency implementation for payment type code "${paymentTypeCode}".`);
  }

  return cryptocurrency;
}

export function getAllAllowedCryptocurrencyTypes(incomingPayment: OpenedIncomingPayment): Array<Cryptocurrency> {
  const checkoutPaymentOptions = getCheckoutPaymentOptionsV2(incomingPayment);
  const cryptocurrencyPaymentOptions: ?ImmutableArray<string> = checkoutPaymentOptions?.cryptocurrency;
  if (!cryptocurrencyPaymentOptions) {
    return [];
  }

  return allCryptocurrencyTypes.filter(cryptocurrency => cryptocurrencyPaymentOptions.includes(cryptocurrency.code));
}
